import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Code from 'UIComponents/elements/Code';
import { getOutputTypeList, getOutputTypeString } from 'automation-ui-formula-editor/formula-editor/action-outputs/OutputTypes';
import I18n from 'I18n';
import FormattedList from 'I18n/components/FormattedList';
import { jsx as _jsx } from "react/jsx-runtime";
export const SYNTAX_ERROR = 'SYNTAX_ERROR';
export const FormulaErrorCategories = {
  SYNTAX_ERROR: 'SYNTAX_ERROR',
  TYPE_ERROR: 'TYPE_ERROR',
  REFERENCE_ERROR: 'REFERENCE_ERROR'
};
export const FormulaErrorTypes = {
  SYNTAX_GENERAL: 'SYNTAX_GENERAL',
  SYNTAX_SPECIFIC: 'SYNTAX_SPECIFIC',
  SYNTAX_PARTIAL_FUNCTION_CALL: 'SYNTAX_PARTIAL_FUNCTION_CALL',
  REFERENCE_UNKNOWN_FUNCTION: 'REFERENCE_UNKNOWN_FUNCTION',
  REFERENCE_UNKNOWN_IDENTIFIER: 'REFERENCE_UNKNOWN_IDENTIFIER',
  REFERENCE_UNKNOWN_FIELD: 'REFERENCE_UNKNOWN_FIELD',
  TYPE_INVALID_FUNCTION_ARGUMENT_COUNT: 'TYPE_INVALID_ARGUMENT_COUNT',
  TYPE_INVALID_FUNCTION_ARGUMENT_TYPE: 'TYPE_INVALID_FUNCTION_ARGUMENT_TYPE',
  TYPE_INVALID_UNARY_OPERATOR_ARGUMENT_TYPE: 'TYPE_INVALID_OPERATOR_ARGUMENT_TYPE',
  TYPE_INVALID_BINARY_OPERATOR_ARGUMENT_TYPE: 'TYPE_INVALID_BINARY_OPERATOR_ARGUMENT_TYPE',
  TYPE_INVALID_ENUM_VALUE: 'TYPE_INVALID_ENUM_VALUE',
  TYPE_INVALID_EXPRESSION_TYPE: 'TYPE_INVALID_EXPRESSION_TYPE',
  TYPE_INVALID_EXPRESSION_OUTPUT: 'TYPE_INVALID_EXPRESSION_OUTPUT'
};
export const ErrorCategoryMeta = {
  [FormulaErrorCategories.SYNTAX_ERROR]: {
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.formula-editor.syntaxError.title"
    }),
    getIconName: () => 'code'
  },
  [FormulaErrorCategories.TYPE_ERROR]: {
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.formula-editor.typeError.title"
    }),
    getIconName: () => 'question'
  },
  [FormulaErrorCategories.REFERENCE_ERROR]: {
    getTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.formula-editor.referenceError.title"
    }),
    getIconName: () => 'warning'
  }
};
export const ErrorTypeMeta = {
  [FormulaErrorTypes.SYNTAX_GENERAL]: {
    category: FormulaErrorCategories.SYNTAX_ERROR,
    getMessage: ({
      message
    } = {}) => {
      if (message) {
        return message;
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.formula-editor.syntaxError.general"
      });
    }
  },
  [FormulaErrorTypes.SYNTAX_SPECIFIC]: {
    category: FormulaErrorCategories.SYNTAX_ERROR,
    getMessage: ({
      found
    }) => {
      if (!found) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.formula-editor.syntaxError.specificIncomplete"
        });
      }
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "automation-ui-formula-editor.formula-editor.syntaxError.specificFound_jsx",
        options: {
          found
        },
        elements: {
          Code
        }
      });
    },
    getMarkLocations: ({
      location
    }) => location && [location]
  },
  [FormulaErrorTypes.SYNTAX_PARTIAL_FUNCTION_CALL]: {
    category: FormulaErrorCategories.SYNTAX_ERROR,
    getMessage: expression => /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "automation-ui-formula-editor.formula-editor.syntaxError.partialFunction_jsx",
      options: {
        name: expression.name
      },
      elements: {
        Code
      }
    })
  },
  [FormulaErrorTypes.REFERENCE_UNKNOWN_FUNCTION]: {
    category: FormulaErrorCategories.REFERENCE_ERROR,
    getMessage: ({
      name
    }) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "automation-ui-formula-editor.formula-editor.referenceError.unknownFunction_jsx",
      elements: {
        Code
      },
      options: {
        name
      }
    }),
    getMarkLocations: context => [context.location]
  },
  [FormulaErrorTypes.REFERENCE_UNKNOWN_IDENTIFIER]: {
    category: FormulaErrorCategories.REFERENCE_ERROR,
    getMessage: ({
      name
    }) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "automation-ui-formula-editor.formula-editor.referenceError.unknownIdentifier_jsx",
      elements: {
        Code
      },
      options: {
        name
      }
    }),
    getMarkLocations: context => [context.location]
  },
  [FormulaErrorTypes.REFERENCE_UNKNOWN_FIELD]: {
    category: FormulaErrorCategories.REFERENCE_ERROR,
    getMessage: ({
      field: {
        name
      }
    }) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "automation-ui-formula-editor.formula-editor.referenceError.unknownField_jsx",
      elements: {
        Code
      },
      options: {
        name
      }
    }),
    getMarkLocations: context => [context.location]
  },
  [FormulaErrorTypes.TYPE_INVALID_FUNCTION_ARGUMENT_COUNT]: {
    category: FormulaErrorCategories.TYPE_ERROR,
    getMarkLocations: context => [context.location],
    getMessage: ({
      totalCount,
      requiredCount,
      found,
      name,
      hasVariadicArguments
    } = {}) => {
      if (found > totalCount) {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "automation-ui-formula-editor.formula-editor.typeError.invalidFunctionArgumentCountHigh_jsx",
          elements: {
            Code
          },
          options: {
            count: totalCount,
            found,
            name
          }
        });
      } else {
        if (hasVariadicArguments) {
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "automation-ui-formula-editor.formula-editor.typeError.invalidFunctionArgumentCountLowInfinite_jsx",
            elements: {
              Code
            },
            options: {
              count: requiredCount,
              found,
              name
            }
          });
        }
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "automation-ui-formula-editor.formula-editor.typeError.invalidFunctionArgumentCountLow_jsx",
          elements: {
            Code
          },
          options: {
            count: requiredCount,
            found,
            name
          }
        });
      }
    }
  },
  [FormulaErrorTypes.TYPE_INVALID_FUNCTION_ARGUMENT_TYPE]: {
    category: FormulaErrorCategories.TYPE_ERROR,
    getMessage: ({
      type,
      expectedTypes,
      argumentNumber,
      name
    }) => {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "automation-ui-formula-editor.formula-editor.typeError.invalidFunctionArgumentType_jsx",
        elements: {
          Code
        },
        options: {
          type: getOutputTypeString(type),
          expectedTypes: getOutputTypeList(expectedTypes),
          argumentNumber,
          name
        }
      });
    },
    getMarkLocations: context => [context.location]
  },
  [FormulaErrorTypes.TYPE_INVALID_UNARY_OPERATOR_ARGUMENT_TYPE]: {
    category: FormulaErrorCategories.TYPE_ERROR,
    getMessage: ({
      type,
      expectedType,
      operator
    } = {}) => {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "automation-ui-formula-editor.formula-editor.typeError.invalidUnaryOperatorArgumentType_jsx",
        elements: {
          Code
        },
        options: {
          type: getOutputTypeString(type),
          expectedType: getOutputTypeString(expectedType),
          operator
        }
      });
    }
  },
  [FormulaErrorTypes.TYPE_INVALID_BINARY_OPERATOR_ARGUMENT_TYPE]: {
    category: FormulaErrorCategories.TYPE_ERROR,
    getMessage: ({
      isLeft,
      type,
      expectedType,
      operator
    }) => {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: isLeft ? 'automation-ui-formula-editor.formula-editor.typeError.invalidBinaryOperatorArgumentTypeLeft_jsx' : 'automation-ui-formula-editor.formula-editor.typeError.invalidBinaryOperatorArgumentTypeRight_jsx',
        elements: {
          Code
        },
        options: {
          type: getOutputTypeString(type),
          isLeft,
          expectedType: getOutputTypeString(expectedType),
          operator
        }
      });
    }
  },
  [FormulaErrorTypes.TYPE_INVALID_ENUM_VALUE]: {
    category: FormulaErrorCategories.TYPE_ERROR,
    getMessage: ({
      value,
      allowedValues,
      argumentNumber,
      name
    }) => {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: 'automation-ui-formula-editor.formula-editor.typeError.invalidEnumValue_jsx',
        elements: {
          Code
        },
        options: {
          value,
          valueList: I18n.formatList(allowedValues, {
            exclusive: true
          }),
          argumentNumber,
          name
        }
      });
    }
  },
  [FormulaErrorTypes.TYPE_INVALID_EXPRESSION_TYPE]: {
    category: FormulaErrorCategories.TYPE_ERROR,
    getMessage: ({
      expressionMode
    }) => {
      return expressionMode.getExpressionError();
    }
  },
  [FormulaErrorTypes.TYPE_INVALID_EXPRESSION_OUTPUT]: {
    category: FormulaErrorCategories.TYPE_ERROR,
    getMessage: ({
      expressionMode
    }) => {
      if (expressionMode && expressionMode.allowedOutputTypes) {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "automation-ui-formula-editor.formula-editor.expressionModes.generalOutputErrorTypes_jsx",
          elements: {
            ListOfTypes: () => /*#__PURE__*/_jsx(FormattedList, {
              exclusive: true,
              children: expressionMode.allowedOutputTypes.map(outputType => getOutputTypeString(outputType).toLowerCase())
            })
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.formula-editor.expressionModes.generalOutputError"
      });
    }
  }
};
export const makeErrorRecord = ({
  type,
  context
}) => {
  if (!type) {
    console.warn('Developer warning: Required argument type for error record is missing');
    return {};
  }
  if (!ErrorTypeMeta[type]) {
    console.warn(`missing error type meta definition for ${type}`);
    return {};
  }
  const getMarkLocations = ErrorTypeMeta[type].getMarkLocations;
  return {
    category: ErrorTypeMeta[type].category,
    message: ErrorTypeMeta[type].getMessage(context),
    markLocations: getMarkLocations ? getMarkLocations(context) : [],
    type,
    context
  };
};